import { render } from "./ListLessons.vue?vue&type=template&id=38716d8c&scoped=true"
import script from "./ListLessons.vue?vue&type=script&lang=js"
export * from "./ListLessons.vue?vue&type=script&lang=js"

import "./ListLessons.vue?vue&type=style&index=0&id=38716d8c&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38716d8c"]])

export default __exports__